import { action } from 'easy-peasy';
import { IActionAddMedication } from '../types';

const addMedication: IActionAddMedication = action((state, payload) => {
  state.items = [payload, ...state.items].sort((a, b) => a.content.localeCompare(b.content));
});

export default addMedication;
